
import {FC} from 'react'
import {ColumnInstance} from 'react-table'
import {ModSession} from "@providers/session/_modals";

type Props = {
  column: ColumnInstance<ModSession>
}

const CustomHeaderColumn: FC<Props> = ({column}) => (
  <>
    {column.Header && typeof column.Header === 'string' ? (
      <th {...column.getHeaderProps()}>{column.render('Header')}</th>
    ) : (
      column.render('Header')
    )}
  </>
)

export {CustomHeaderColumn}
